var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5781_91524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5781_91524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 27.4993C12.8751 27.4993 12.4829 27.3363 12.1567 27.0102C11.8301 26.6835 11.6667 26.291 11.6667 25.8327V16.666C11.6667 16.2077 11.8301 15.8155 12.1567 15.4893C12.4829 15.1627 12.8751 14.9993 13.3334 14.9993H16.6667V13.3327C16.6667 12.8743 16.8301 12.4818 17.1567 12.1552C17.4829 11.8291 17.8751 11.666 18.3334 11.666H21.6667C22.1251 11.666 22.5176 11.8291 22.8442 12.1552C23.1704 12.4818 23.3334 12.8743 23.3334 13.3327V14.9993H26.6667C27.1251 14.9993 27.5176 15.1627 27.8442 15.4893C28.1704 15.8155 28.3334 16.2077 28.3334 16.666V25.8327C28.3334 26.291 28.1704 26.6835 27.8442 27.0102C27.5176 27.3363 27.1251 27.4993 26.6667 27.4993H13.3334ZM18.3334 14.9993H21.6667V13.3327H18.3334V14.9993ZM26.6667 22.4993H22.5001V24.166H17.5001V22.4993H13.3334V25.8327H26.6667V22.4993ZM19.1667 22.4993H20.8334V20.8327H19.1667V22.4993ZM13.3334 20.8327H17.5001V19.166H22.5001V20.8327H26.6667V16.666H13.3334V20.8327Z",
    fill: "#8D8885"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales2);
export default __webpack_public_path__ + "static/media/sales2.bdfda31255c558b927a71e5f876f89fd.svg";
export { ForwardRef as ReactComponent };